'use client';

import { useEffect, useState } from 'react';
import { buildBetterStackTagScript } from '@/lib/betterstack-tag';
import { detectGpc, hasConsentFor } from '@/lib/consent';

function canLoadAnalytics(): boolean {
  return !detectGpc() && hasConsentFor('analytics');
}

export function BetterStackConsentLoader() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const sync = () => setEnabled(canLoadAnalytics());
    sync();
    window.addEventListener('storage', sync);
    window.addEventListener('purebox:consent-changed', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('purebox:consent-changed', sync);
    };
  }, []);

  useEffect(() => {
    if (!enabled || window.betterstack) return;
    const scriptText = buildBetterStackTagScript();
    if (!scriptText) return;

    const script = document.createElement('script');
    script.dataset.pureboxAnalytics = 'betterstack';
    script.text = scriptText;
    document.head.appendChild(script);
  }, [enabled]);

  return null;
}
